<template>
  <div class="timer"
       :class="{
         'timer--product': isProductPage,
         'timer--on-page-small': isCountdownOnPageSmall,
         'timer--on-page-big': isCountdownOnPageBig,
         'timer--light': type === 'light'
       }"
       v-if="currentTime">
    <div class="timer__title-wrap" :class="{ 'timer__title-wrap--product': isProductPage }" v-if="title && !isCountdownOnPageSmall && !isCountdownOnPageBig">
      <h2 class="timer__title">{{ title }}</h2>
    </div>
    <div class="timer__wrap">
      <div class="timer__container" :class="{ 'timer__container--product': isProductPage }">
        <span class="timer__number">{{ currentTime.days }}</span>
        <span class="timer__text" v-if="!isCountdownOnPageSmall">{{
          [$t('timer.day1'), $t('timer.day2'), $t('timer.day3')]
            | Pluralize(currentTime.days)
        }}</span>
      </div>
      <span class="timer__days" v-if="title && isCountdownOnPageSmall">
        <span>
          {{
            [$t('timer.day1'), $t('timer.day2'), $t('timer.day3')]
              | Pluralize(currentTime.days)
          }}
        </span>
        <span>
          {{ $t('count_expiration') }}
        </span>
      </span>
      <span class="timer__divider" v-if="title && isCountdownOnPageSmall"></span>
      <span v-if="isProductPage" class="timer__dots">:</span>
      <div class="timer__container" :class="{ 'timer__container--product': isProductPage }">
        <span class="timer__number">{{ ('0' + currentTime.hours).slice(-2) }}</span>
        <template v-if="!isCountdownOnPageSmall">
          <span class="timer__text" v-if="isProductPage">{{ $t('count_hour') }}</span>
          <span class="timer__text" v-else>{{
            [$t('timer.hour1'), $t('timer.hour2'), $t('timer.hour3')]
              | Pluralize(currentTime.hours)
          }}</span>
        </template>
      </div>
      <span v-if="isProductPage || isCountdownOnPageSmall" class="timer__dots">:</span>
      <div class="timer__container" :class="{ 'timer__container--product': isProductPage }">
        <span class="timer__number">{{ ('0' + currentTime.minutes).slice(-2) }}</span>
        <template v-if="!isCountdownOnPageSmall">
          <span class="timer__text" v-if="isProductPage">{{ $t('count_minute') }}</span>
          <span class="timer__text" v-else>{{
            [$t('timer.minutes1'), $t('timer.minutes2'), $t('timer.minutes3')]
              | Pluralize(currentTime.minutes)
          }}</span>
        </template>
      </div>
      <span v-if="isProductPage || isCountdownOnPageSmall" class="timer__dots">:</span>
      <div class="timer__container" :class="{ 'timer__container--product': isProductPage }">
        <span class="timer__number">{{ ('0' + currentTime.seconds).slice(-2) }}</span>
        <template v-if="!isCountdownOnPageSmall">
          <span class="timer__text" v-if="isProductPage">{{ $t('count_second') }}</span>
          <span class="timer__text" v-else>{{
            [$t('timer.seconds1'), $t('timer.seconds2'), $t('timer.seconds3')]
              | Pluralize(currentTime.seconds)
          }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Pluralize from '../../filters/Pluralize'

export default {
  name: 'Timer',
  filters: {
    Pluralize
  },
  props: {
    deadline: {
      type: [String, Number],
      required: true
    },
    speed: {
      type: Number,
      default: 1000
    },
    title: {
      type: String,
      default: ''
    },
    isProductPage: Boolean,
    isCountdownOnPageSmall: Boolean,
    isCountdownOnPageBig: Boolean,
    type: {
      type: String,
      default: 'dark'
    }
  },
  data () {
    return {
      currentTime: null
    }
  },
  watch: {
    deadline: {
      immediate: true,
      handler (value) {
        if (value) {
          this.countdown()
        }
      }
    }
  },
  methods: {
    countdown () {
      let t = new Date(+this.deadline * 1000) - Date.parse(new Date())
      let seconds = Math.floor((t / 1000) % 60)
      let minutes = Math.floor((t / 1000 / 60) % 60)
      let hours = Math.floor((t / (1000 * 60 * 60)) % 24)
      let days = Math.floor(t / (1000 * 60 * 60 * 24))

      if (t > 0) {
        this.currentTime = {
          total: t,
          days: days,
          hours: hours,
          minutes: minutes,
          seconds: seconds
        }

        setTimeout(this.countdown, this.speed)
      } else {
        this.$emit('closeTimer')
        this.currentTime = null
      }
    }
  }
}
</script>

<style scoped lang="sass">

.timer
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  width: 100%
  &--on-page-big
    .timer__wrap
      margin-top: 0 !important
    .timer__container
      border: none
      width: 60px !important
      +mmax(798)
        width: 54px !important
      &:first-child
        width: auto !important
    .timer__dots
      font-size: 28px !important
    .timer__number
      font-size: 33px !important
      line-height: 1.2 !important
      font-weight: 500
      +mmax(798)
        font-size: 30px !important
    .timer__text
      font-size: 12px !important
      font-weight: 700
  &--on-page-small
    .timer__divider
      width: 0
      height: 50px
      border: 1px solid rgba(144, 144, 144, 0.3)
      margin-right: 20px
      margin-left: 20px
      +mmax(1130)
        margin-right: 12px
        margin-left: 12px
    .timer__days
      text-transform: uppercase
      font-weight: 700
      font-size: 10px
      line-height: 13px
      margin: 0 0 0 15px
      display: flex
      flex-direction: column
      +mmax(1130)
        margin: 0 0 0 10px
    .timer__number
      font-size: 48px
      font-weight: 400
      +mmax(1130)
        font-size: 36px
    .timer__dots
      margin: 0 3px
      height: 100%
      display: flex
      align-items: center
      font-size: 48px
      font-weight: 400
      +mmax(1130)
        font-size: 36px
    .timer__container
      width: 48px
      height: 50px
      border: none
      border-radius: 0
      margin: 0 !important
      &:first-child
        width: auto
      +mmax(1130)
        width: 40px
  &--product
    width: auto
    align-items: flex-start

    +mmin($small)
      align-items: center

    +mmin($tablet)
      align-items: flex-start

    +mmin($large)
      align-items: center

    .timer__wrap
      margin-top: 10px

    .timer__days
      color: #333333
      opacity: 0.7
    .timer__container
      border-color: rgba(0, 0, 0, 0.2)

    .timer__number
      color: $text-color

    .timer__text
      color: $text-color

    .timer__title
      color: $text-color
      text-transform: none
      font-size: 14px
      font-weight: 400
      letter-spacing: normal

    .timer__dots
      color: $text-color
    &.timer--light
      .timer__title
        color: #fff
      .timer__number, .timer__text
        color: $text-color

.timer__wrap
  display: flex
  flex-flow: row nowrap
  align-items: center

.timer__container
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 10px 0 10px
  width: 70px
  border: 2px solid #2d2d2d
  border-radius: 10px

  &:not(:last-child)
    margin-right: 20px

  +mmin($tablet--hor)
      width: 150px

  &--product
    width: 48px
    border-color: rgba(255, 255, 255, 0.25)
    padding: 5px 10px
    border-radius: 7px

    &:not(:first-child)
      margin-left: 3px

    &:not(:last-child)
      margin-right: 3px

    .timer__number
      font-size: 25px
      line-height: 100%

    .timer__text
      margin: 0
      font-size: 10px
      line-height: 100%
      text-transform: none
      font-weight: 400

.timer__title-wrap
  margin-bottom: 40px

  &--product
    margin: 0

  .timer__title
    margin: 0

.timer__number
  font-size: 25px
  color: $text-color

  +mmin($tablet--hor)
    font-size: 45px

.timer__text
  display: block
  margin-top: -2px
  font-size: 10px
  color: $text-color
  opacity: 0.6
  letter-spacing: 0.15em
  text-transform: uppercase

  +mmin($tablet--hor)
    margin-top: 8px
    font-size: 12px

.timer__title
  font-size: 18px
  letter-spacing: 0.1em
  text-transform: uppercase
  color: $text-color

.timer__dots
  color: $text-color
  font-size: 26px
  font-weight: 400

.timer__days
  color: $text-color
  opacity: 0.7

.timer--light
  .timer__days
    color: #fff
    opacity: 0.7
  .timer__container
    border-color: rgba(0, 0, 0, 0.2)

  .timer__number
    color: #fff

  .timer__text
    color: #fff

  .timer__title
    color: #fff

  .timer__dots
    color: #fff
</style>
